<template>
  <div id="call-forward" class="position-relative">
    <div class="social-nav filter-blur-50">
      <div class="nameContainer" :class="this.$lang === 'ar' ? 'right-dir' : ''">
        <router-link to="/personal" class="d-flex">
          <div class="homeIcon">
            <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
          </div>
        </router-link>
        <div class="arrowIcon" :class="this.$lang === 'ar' ? 'rotate' : ''">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <router-link to="/profile" class="d-flex">
          <div class="featureTitle">
            {{$t('featureController.title')}}
          </div>
        </router-link>
        <div class="arrowIcon" :class="this.$lang === 'ar' ? 'rotate' : ''">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <div class="titleName">{{$t('profile.callForward')}}</div>
      </div>
    </div>
    <div style="min-height: calc(100vh - 289.08px); display: flex; align-items: center; justify-content: center; flex-direction: column; ">
      <div v-if="!showLoading" class="main-cont w-100">
        <div class="card-container">
          <br><br>
          <div :class="[this.$lang === 'ar' ? 'right-dir' : 'left-dir', 'wrapper']">
            <div class="header">
              <div class="flexing">
                <div :class="[this.$lang === 'ar' ? 'bold-ar': 'bold-en', 'titles']">{{ main.title }}</div>
                <label class="switch">
                  <input @click="activateFeature" v-model="main.checked" type="checkbox">
                  <span :style="{borderColor: main.checked ? '#FFCB05' : '', boxShadow: main.checked ? ' 0px 0px 5px rgb(205,203,5)' : ' 0px 0px 5px rgb(106,106,106)'}" class="slider"></span>
                  <div :style="{transform : main.checked ? 'translateX(1.2em)' : 'translateX(0em)'}" class="slider-border"></div>
                </label>
              </div>
              <div class="mini-title" :class="[this.$lang === 'ar' ? 'text-right' : 'text-left']">
                <span :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ main.price }}</span>
              </div>
            </div>
            <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'description']" class="d-flex">
              {{main.description}}
            </div>
          </div>
          <div class="options-cont position-relative" :class="this.$lang === 'ar' ? 'right-dir' : ''">
            <div class="opacity-layout" v-if="!main.checked"></div>
            <div v-for="(item,i) in options" :key="i">
              <div class="option">
                <div class="d-flex align-items-center"><div class="ball-white-3"></div><span class="name" :class="$lang === 'ar' ? 'ml-2' : 'mr-2'">{{item.name}}</span><span class="desc d-sm-block d-none">{{item.desc}}</span></div>
                <label class="switch">
                  <input @click="activateOption(i)" v-model="item.checked" type="checkbox">
                  <span :style="{borderColor: item.checked ? '#FFCB05' : '', boxShadow: item.checked ? ' 0px 0px 5px rgb(205,203,5)' : ' 0px 0px 5px rgb(106,106,106)'}" class="slider"></span>
                  <div :style="{transform : item.checked ? 'translateX(1.2em)' : 'translateX(0em)'}" class="slider-border"></div>
                </label>
              </div>
              <span class="desc d-sm-none d-block mt-3" :class="$lang === 'ar' ? 'text-right' : 'text-left'">{{item.desc}}</span>
              <div class="d-flex input-cont">
                <img src="../../assets/icons/contactNumber.svg">
                <input :placeholder="$t('feature.enter')" v-model="item.value" :disabled="!item.checked" type="text" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');">
              </div>
              <div v-if="!valid(item.value) && item.checked && showError" :class="[lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('validation')}}</div>
              <div class="border-cont" v-if="i !== options.length - 1"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!showLoading" class="feature-footer" :class="this.$lang === 'ar' ? 'right-dir' : ''">
      <span class="cancel" @click="showCallForward">
        {{$t('actions.cancel')}}
      </span>
        <span v-if="!isLoading" class="submit" @click="handleSubmit">
         {{$t('submit')}}
        </span>
        <div v-if="isLoading" class="spinner-border text-light" role="status"></div>
      </div>
      <Loader v-if="showLoading" style="padding-top: 160px;" />
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import CallForwardRepository from '../../repositories/CallForwardRepository'
import ms from '../../utils/messeging'
import Loader from '../LoaderBtn/Loader'
export default {
  name: 'callForward',
  components: { Loader },
  data () {
    return {
      lang: this.$lang,
      showError: false,
      isLoading: false,
      showLoading: false,
      callForwardRepo: new CallForwardRepository(),
      main: {
        id: null,
        checked: false,
        title: '',
        price: '',
        type: 0,
        description: ''
      },
      options: [
        {
          checked: false,
          name: this.$t('feature.busy'),
          desc: this.$t('feature.forward'),
          value: ''
        },
        {
          checked: false,
          name: this.$t('feature.reach'),
          desc: this.$t('feature.forward'),
          value: ''
        },
        {
          checked: false,
          name: this.$t('feature.answer'),
          desc: this.$t('feature.forward'),
          value: ''
        },
        {
          checked: false,
          name: this.$t('feature.all'),
          desc: this.$t('feature.forward'),
          value: ''
        }
      ]
    }
  },
  created () {
    this.showCallForward()
  },
  mounted () {
    this.style()
  },
  methods: {
    valid (val) {
      const regex = /^[0][9][0-9]{8}$/
      return regex.test(val)
    },
    activateOption (i) {
      this.options[i].checked = !this.options[i].checked
    },
    activateFeature () {
      this.main.checked = !this.main.checked
      if (!this.main.checked) {
        for (let i = 0; i < this.options.length; i++) {
          this.options[i].checked = false
        }
      }
    },
    async showCallForward () {
      if (this.showLoading) {
        return
      }
      this.showLoading = true
      const data = new FormData()
      data.append('gsm', this.$store.state.selectedNumber)
      try {
        const response = await this.callForwardRepo.show(data)
        if (response.data.status === 200) {
          this.main.title = response.data.data.title
          this.main.description = response.data.data.description
          this.main.price = response.data.data.price === 0 ? this.$t('free') : response.data.data.price + this.$t('Bundles.sp')
          this.main.checked = response.data.data.serviceState === 1
          const customerState = response.data.data.customerState
          for (let i = 0; i < customerState.length; i++) {
            if (customerState[i].type === 0) {
              this.options[3].checked = customerState[i].state === 1
              this.options[3].value = customerState[i].number
            } else if (customerState[i].type === 1) {
              this.options[0].checked = customerState[i].state === 1
              this.options[0].value = customerState[i].number
            } else if (customerState[i].type === 2) {
              this.options[2].checked = customerState[i].state === 1
              this.options[2].value = customerState[i].number
            } else if (customerState[i].type === 3) {
              this.options[1].checked = customerState[i].state === 1
              this.options[1].value = customerState[i].number
            }
          }
          // ms.successMessage(response.data.message)
        } else {
          // ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            // ms.errorMessage(e.response.data.message)
          }
        } catch {
          // ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.showLoading = false
    },
    async handleSubmit () {
      this.showError = true
      if (this.isLoading) {
        return
      }
      for (let k = 0; k < this.options.length; k++) {
        if (this.options[k].checked && !this.valid(this.options[k].value)) {
          return
        }
      }
      this.isLoading = true
      const formData = new FormData()
      formData.append('gsm', this.$store.state.selectedNumber)
      formData.append('serviceState', this.main.checked ? 1 : 0)
      for (let i = 0; i < this.options.length; i++) {
        if (i === 3) {
          formData.append('customerState[0].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[0].type', 0)
          formData.append('customerState[0].number', this.options[i].value)
        } else if (i === 0) {
          formData.append('customerState[1].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[1].type', 1)
          formData.append('customerState[1].number', this.options[i].value)
        } else if (i === 2) {
          formData.append('customerState[2].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[2].type', 2)
          formData.append('customerState[2].number', this.options[i].value)
        } else if (i === 1) {
          formData.append('customerState[3].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[3].type', 3)
          formData.append('customerState[3].number', this.options[i].value)
        }
      }
      try {
        const response = await this.callForwardRepo.activate(formData)
        if (response.data.status === 200) {
          this.showCallForward()
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.isLoading = false
    },
    style () {
      if (this.$lang === 'ar') {
        $('#call-forward').css('font-family', 'Mtn-arabic-regular')
        $('#call-forward .featureTitle').css('font-family', 'Mtn-arabic-regular')
        $('#call-forward .titleName').css('font-family', 'Mtn-arabic-regular')
      } else {
        $('#call-forward').css('font-family', 'Mtn-regular')
        $('#call-forward .featureTitle').css('font-family', 'Mtn-regular')
        $('#call-forward .titleName').css('font-family', 'Mtn-regular')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
.validation {
  width: 100%;
}
.spinner-border {
  color: $--yellow !important;
}
.opacity-layout {
  border-top-right-radius: 22px; border-top-left-radius: 22px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  left: 0;
  backdrop-filter: blur(40px);
  background-image: linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -moz-background-image: -moz-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -o-background-image: -o-linear-gradient(to bottom,rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -webkit-background-image: -webkit-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
}
.cancel, .submit {
  font-size: 15px; text-decoration: underline; cursor: pointer;
}
.submit {
  color: $--yellow; font-weight: bold;
}
.border-cont {
  height: 2px; width: 100%;
  background: rgba(29, 29, 29, 0.30);
  margin: 1.5rem 0;
}
.input-cont {
  padding: 0 18px;
  display: flex!important; justify-content: center; align-items: center;
  margin-top: 0.8rem;
  border: 2px rgba(29, 29, 29, 0.75) solid;
  border-radius: 18px;
  //height: 55px;
  //width: 430px;
  height: 50px;
  width: 410px;
  input {
    padding: 0 10px;
    width: 100%; height: 100%;
  }
  img {
    width: 20px;
  }
}
//@media screen and (max-width: 1400px){
//  .input-cont {
//    width: 430px!important;
//  }
//}
@media screen and (max-width: 600px){
  .input-cont {
    width: 310px!important;
  }
}
@media screen and (max-width: 360px){
  .input-cont {
    width: 270px!important;
    margin: 1rem auto;
  }
}
.desc{
  font-style: italic;
  font-size: 13px;
}
.options-cont {
  min-height: calc(100vh - 585px);
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  border-top: 2.5px solid rgba(255, 255, 255, 0.75); border-top-right-radius: 22px; border-top-left-radius: 22px;
  padding: 50px 3rem 100px 3rem;
  width: 100%; backdrop-filter: blur(40px);
  background-image: linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -moz-background-image: -moz-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -o-background-image: -o-linear-gradient(to bottom,rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -webkit-background-image: -webkit-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  .option {
    display: flex; align-items: center; justify-content: space-between;
    .name {
      font-size: 17px;
      font-weight: bold;
      color: $--yellow;
    }
    .ball-white-3 {
      width: 6px; height: 6px;
      background: $--yellow;
    }
  }
}
@media screen and (max-width: 800px){
  .options-cont {
    padding: 50px 1.5rem 100px 1.5rem !important;
  }
}
//#call-forward
#call-forward .main-cont {
  padding-top: 160px;
  background: url("../../assets/images/callForward.png") no-repeat;
  background-size: cover;
}
#call-forward .social-nav{
  height: 50px;
  background: rgba(242, 242, 242, 1);
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
  margin: 0px 0px;
  display: flex;
  position: fixed;
  z-index: 10;
  z-index: 210;
  top: 110px;
}
#call-forward .nameContainer{
  width: 100vw;
  display: flex;
  padding: 0 4vw 0 3.2vw;
}
#call-forward .homeIcon {
  cursor: pointer;
}
.homeIcon,
.arrowIcon,
.titleName{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
}
#call-forward .titleName{
  width: max-content;
  color: $--yellow;
  //font-family: Mtn-bold;
  text-decoration: underline;
  font-weight: 900;
}
#call-forward .featureTitle{
  width: max-content;
  font-family: Mtn-regular;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
}
//switch button
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 2.8em;
  height: 1.5em;
  border-radius: 50px;
  box-shadow: 10px 10px 20px rgba(0,0,0,0.08);
  background: #F2F2F2;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  border: 1px solid rgb(106,106,106);
  border-radius: 50px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  //filter: blur(1px);
}

.slider:before {
  position: absolute;
  content: "";
  height: 1em;
  width: 1em;
  left: 0.2em;
  bottom: 0.18em;
  background: rgb(106,106,106);
  border-radius: inherit;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
}
.slider-border {
  height: .95em;
  width: .95em;
  border: .8px solid #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 0.295em;
  bottom: 0.25em;
  filter: blur(1px);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  cursor: pointer;
}

.switch input:checked + .slider:before {
  transform: translateX(1.2em);
  background-color: $--yellow;
}
/*---------------------------------*/
/*---------------------------------*/
.wrapper {
  padding: 0 3rem;
}
.flexing {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titles {
  font-style: italic;
  color: $--yellow;
  font-size: 22px
}
.mini-title > span:first-child {
  font-size: 16px
}
.mini-title > span:last-child {
  font-size: 17px
}
.description {
  width: 100%;
  font-size: 13px;
  padding: 1rem  0;
  color: #707070;
}
/*----------------- responsive -------------------------*/
@media (max-width: 800px) {
  .wrapper {
    padding: 0 1.5rem
  }
}
/*-------------------------------------------------------*/
.feature-footer {
  position: absolute; bottom: 0; width: 100%; display: flex;
  justify-content: space-between; align-items: center;
  height: 58px;
  background: #F6F6F6;
  padding: 0 4vw;
}
.rotate {
  transform: rotate(180deg);
}
</style>
